import { ReportComponentsVisualizationsFacade } from './facades/components-visualizations.facade';
import {
  AppliedFiltersBreadcrumbsService,
  DateBreadcrumbsService,
  DatePointsBreadcrumbsService,
  ReportsBreadcrumbsService,
} from './services/breadcrumbs';
import { ReportsFilterTranslationsService } from './services/filters-translations.service';
import { ReportFiltersRepo } from './services/report-filters.repo';

export const provideCoreReportsBreadcrumbsServices = () => [
  AppliedFiltersBreadcrumbsService,
  ReportsBreadcrumbsService,
  DateBreadcrumbsService,
  DatePointsBreadcrumbsService,
];

export const provideCoreReportsLogic = () => [
  ReportsFilterTranslationsService,
  ReportFiltersRepo,
  ReportComponentsVisualizationsFacade,
];
